import { render, staticRenderFns } from "./ModalBajaUsuario.vue?vue&type=template&id=53eb481a&"
import script from "./ModalBajaUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalBajaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports